import React from "react";

import "./demarcation.m.css";

const Demarcation = () => <div styleName="wrapper" />;

export default Demarcation;
